/** List of available variable names used by the app */
export const variableNames = ["temperature", "salinity", "wind", "current"] as const;
export const norwegianVariableNames = ["temperatur", "saltholdighet", "vind", "strøm"] as const;

/** The type representing the available variable names used by the app */
export type VariableNames = (typeof variableNames)[number];
export type NorwegianVariableNames = (typeof norwegianVariableNames)[number];
